module.exports = __webpack_public_path__ + "home_intro_2.9bed33095fbc8123593e.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_intro_2.jpg
// module id = ../../../../../src/assets/img/home_intro_2.jpg
// module chunks = styles